// extracted by mini-css-extract-plugin
export var footer = "_p8-0";
export var inherit = "_p8-1";
export var input = "_p8-2";
export var modalContent = "_p8-3";
export var quillEditor = "_p8-4";
export var subtitle = "_p8-5";